import { useAppDispatch } from "../../../../app/hooks";
import DialogComponent from "../../../../common/components/functional/dialogs/DialogComponent";
import DialogContentWrapper from "../../../../common/components/functional/dialogs/DialogContentWrapper";
import { CreateCompanyForm } from "./CreateCompanyForm";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { createCustomerCompany } from "../../customerOrganizationsSlice";
import { isFulfilled } from "@reduxjs/toolkit";
import useIsLoading from "../../../../hooks/useIsLoading";
import useMessage from "../../../../hooks/useMessage";
import { routes } from "../../../../app/paths";

type Props = {
  open: boolean;
  onClose: () => void;
};

export const CreateCompanyDialog = ({ open, onClose: handleClose }: Props) => {
  const dispatch = useAppDispatch();
  const isLoading = useIsLoading(["customerOrganizations"]);
  const { t } = useTranslation("customers");
  const { sendMessage } = useMessage();

  const defaultValues = {
    businessId: "",
    name: "",
    customerNumber: "",
  };

  const methods = useForm({
    defaultValues,
    mode: "onChange",
  });

  const saveDisabled =
    !methods.formState.isValid || methods.formState.isSubmitting || isLoading;

  const onClose = () => {
    methods.reset();
    handleClose();
  };

  const onSave = (data: any) => {
    dispatch(createCustomerCompany(data)).then((action) => {
      if (isFulfilled(action)) {
        const orgAdded = action.payload.find(
          (event) => event.name === "orgAdd",
        );
        if (orgAdded) {
          sendMessage(t("customerCreated"), "success", {
            link: routes.customerBasicInfo(orgAdded.payload.companyId, {
              org: orgAdded.id,
            }),
          });
        }
        onClose();
      }
    });
  };

  return (
    <DialogComponent open={open} onClose={onClose} sx={{ maxWidth: "550px" }}>
      <FormProvider {...methods}>
        <DialogContentWrapper
          title={t("customerInfo")}
          onSave={methods.handleSubmit(onSave)}
          onCancel={onClose}
          saveDisabled={saveDisabled}
          customSaveButtonLabel={t("common:save")}
        >
          <CreateCompanyForm />
        </DialogContentWrapper>
      </FormProvider>
    </DialogComponent>
  );
};
